import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocaleService } from './locale.service';

@Injectable({
	providedIn: 'root',
})
export class SnackService {
	constructor(private snackBar: MatSnackBar, private locale: LocaleService) {}

	open(message: string, time: number = 5000, action: string = null, type: 'success' | 'error' = 'success') {
		if (this.locale.lang === 'en') {
			this.snackBar.open(message, action, {
				duration: time,
				direction: 'ltr',
				panelClass: [type],
			});
		} else {
			this.snackBar.open(message, action, {
				duration: time,
				direction: 'rtl',
				panelClass: [type],
			});
		}
	}
}
